import { useRef } from "react";

export type ReconnectListener = () => void;

interface IReconnectListeners {
	add(listener: ReconnectListener): void;
	remove(listener: ReconnectListener): void;
	process(): void;
}

function useReconnectListeners(

): IReconnectListeners {

	const listenersRef = useRef<ReconnectListener[]>([]);

	function add(listener: ReconnectListener) {
		listenersRef.current.push(listener);
	}

	function remove(listener: ReconnectListener) {
		const idx = listenersRef.current.indexOf(listener);
		if (idx > -1) {
			listenersRef.current.splice(idx, 1);
		}
	}

	function process() {
		listenersRef.current.forEach(listener => {
			listener();
		})
	}

	return {
		add,
		remove,
		process
	}
}

export default useReconnectListeners;